import ContentEditorProvider from 'personalization-lib/components/wrappers/ContentEditorProvider';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A wrapper that enables use of content editor personalization features.
 * @param tracker - The tracker instance.
 * @param appName - The name of the app, used for tracking.
 * @param screen - The name of the screen, used for tracking.
 * @param assetData - The data for the asset being edited. Ensure that personalization features are only used when this has been passed.
 * @param children - The children to render.
 * @returns The children component wrapped with the content editor personalization context.
 */
const ContentEditorPersonalizationProvider = ({
  tracker,
  appName,
  screen,
  assetData,
  children
}) => {
  if (!assetData) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(ContentEditorProvider, {
    tracker: tracker,
    appName: appName,
    screen: screen,
    assetData: assetData,
    children: children
  });
};
export default ContentEditorPersonalizationProvider;